import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-epb-gpm',
  templateUrl: './epb-gpm.component.html',
  styleUrls: ['./epb-gpm.component.scss']
})
export class EpbGpmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
